import { fade, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  fullWidth:{
    width: '100%'
  },
  searchBarWrapper: {
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: theme.spacing(0.875),
    padding: theme.spacing(2.25, 1.5),
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap'
    },
    '&.alignEnd': {
      justifyContent: 'flex-end'
    }
  },
  invoicesHeader: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    },
    '& h5': {
      whiteSpace: 'nowrap'
    }
  },
  directionFormWrapper: {
    marginLeft: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      marginLeft: theme.spacing(0)
    },
    minWidth: 160
  },
  uuidWrapper: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      marginRight: theme.spacing(0.375)
    },
    '& $cellDataWrapper': {
      width: 'calc(100% - 24px)'
    }
  },
  statusWrapper: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 1.7,
    marginLeft: theme.spacing(0.375),
    '& svg': {
      marginRight: theme.spacing(0.5),
      fontSize: theme.typography.pxToRem(20)
    },
    '&.valid': {
      color: theme.palette.success.main,
      '&.freeze':{
        color: theme.palette.grey[500],
      }
    },
    '&.invalid': {
      color: theme.palette.warning.dark
    },
    '&.cancelled': {
      color: theme.palette.grey[400]
    },
    '&.rejected': {
      color: theme.palette.error.main
    },
    '&.submitted': {
      color: theme.palette.success.dark
    },
    '&.spStatus': {
      color: theme.palette.colors.logoColor
    }

  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(0.5),
    '& > svg': {
      fontSize: theme.typography.pxToRem(20),
      color: theme.palette.text.disabled,
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1)
    }
  },
  statusDelayed: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    '& span': {
      marginLeft: theme.spacing(0.5)
    }
  },
  downloadProgressWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000
  },
  progress: {
    width: 200,
    marginLeft: 35,
    height: 10,
    marginTop: theme.spacing(10),
    borderRadius: theme.spacing(1),
    '& .MuiLinearProgress-root': {
      height: 8,
      borderRadius: theme.spacing(1)
    }
  },

  cellDataWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& a': {
      maxWidth: 245,
      width: '100%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    '& span': {
      fontSize: theme.typography.pxToRem(12)
    }
  },
  searchBarAddNewButton: {
    '&.MuiButton-root': {
      minWidth: 146,
      minHeight: 37,
      lineHeight: 1.5,
      flex: '0 0 auto',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(0.5),
      marginRight: theme.spacing(8),
      padding: theme.spacing(1, 3.25)
    },
    '& svg': {
      marginRight: theme.spacing(1)
    }
  },
  phoneWrapper: {
    direction: theme.direction === 'rtl' ? 'rtl' : 'ltr',
    display: 'inline-block',
    whiteSpace: 'nowrap'
  },
  colorBoxWrapper: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    transition: 'all 0.3s ease-in-out',
    marginRight: theme.spacing(1.5)
  },
  colorListWrapper: {
    textAlign: 'left'
  },
  colorWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    '&.center': {
      justifyContent: 'center'
    },
    '& h6': {
      whiteSpace: 'nowrap',
      marginRight: theme.spacing(1.25),
      marginTop: theme.spacing(-0.5),
      width: 68
    },
    '&.in-filter-chip': {
      marginRight: theme.spacing(1),
      '& $colorBoxWrapper': {
        marginRight: theme.spacing(0.325)
      },
      [theme.breakpoints.down('xs')]: {
        '& $phoneWrapper': {
          display: 'none'
        }
      }
    }
  },
  FilterChip: {
    display: 'flex',
    alignItems: 'center',
    '& > span': {
      marginLeft: theme.spacing(1),
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      '&.has-color': {
        display: 'flex'
      }
    }
  },
  ApplyFilterWrapper: {
    marginTop: theme.spacing(4),
    textAlign: 'right'
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'flex-start !important',
    color: theme.palette.common.white,
    '& .MuiPickersToolbarText-toolbarTxt': {
      color: fade(theme.palette.common.white, 0.54)
    },
    '& .MuiPickersToolbarText-toolbarBtnSelected': {
      color: theme.palette.common.white
    }
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  chip: {
    margin: theme.spacing(0.5)
  },

  paginationWithToken:{
    display: 'flex',
    alignItems: 'center',
    justifyContent:'flex-end',
    '& span.per-page':{
      margin:'0 10px 0 0'
    }
  },

  submissionDateContainer: {
    margin: '-12px 10px 0',
    '& span':{
      padding:'0 10px'
    }
  },
  submissionDate: {
    display: 'flex',
    alignItems: 'center',
  },
  submissionDateTo: {
    display: 'flex',
    alignItems: 'center',
    margin: '-20px 0',
  },

  
}))
